export default function reducer(state, action) {
  switch (action.type) {
    // Basic data
    // Homework to do
    case "SET_TODO": {
      return { ...state, todo: { ...state.todo, [action.userId || "*"]: action.todo } };
    }
    // Homework
    case "SET_HOMEWORK": {
      const newState = {
        ...state,
        homeworks: {
          ...state.homeworks,
          [action.id]: {
            ...(state.homeworks[action.id] || {}),
            [action.userId || "*"]: action.homework,
          },
        },
      };

      if (!action.homework) {
        // Clear every work/to do that uses it
        newState.todo = Object.keys(state.todo).reduce(
          (todos, userId) =>
            Object.assign(todos, userId === (action.userId || "*") ? {} : state.todo[userId]),
          {}
        );
      }

      return newState;
    }
    // Milestone
    case "SET_MILESTONE": {
      const newState = {
        ...state,
        milestones: {
          ...state.milestones,
          [action.id]: {
            ...(state.milestones[action.id] || {}),
            [action.userId || "*"]: action.milestone,
          },
        },
      };

      if (!action.milestone) {
        // Clear every work/to do that uses it
        newState.homeworks = Object.keys(state.homeworks).reduce(
          (homeworks, homeworkId) =>
            Object.assign(
              homeworks,
              state.homeworks[homeworkId] &&
                Object.keys(state.homeworks[homeworkId]).reduce(
                  (users, userId) =>
                    Object.assign(
                      users,
                      state.homeworks[homeworkId][userId] &&
                        (state.homeworks[homeworkId][userId].milestones || []).find(
                          (m) => m.id === action.id
                        )
                        ? {}
                        : state.homeworks[homeworkId][userId]
                    ),
                  {}
                )
            ),
          {}
        );
        newState.todo = Object.keys(state.todo).reduce(
          (todos, userId) =>
            Object.assign(todos, userId === (action.userId || "*") ? {} : state.todo[userId]),
          {}
        );
      }

      return newState;
    }

    // Dialogs
    // Homework selection
    case "SELECT_HOMEWORK": {
      return { ...state, selectedHomework: action.id, selectedHomeworkFrom: action.userId };
    }
    // Milestone validation
    case "VALIDATE_MILESTONE": {
      return { ...state, milestoneValidation: action.id, milestoneValidationFrom: action.userId };
    }
    // List creation
    case "CREATE_LIST": {
      return {
        ...state,
        createList: {
          from: action.userId,
          list: action.listId,
        },
      };
    }
    case "CLOSE_CREATE_LIST": {
      return { ...state, createList: null };
    }
    // Homework creation
    case "CREATE_HOMEWORK": {
      return {
        ...state,
        createHomework: {
          list: action.listId,
          homework: action.homeworkId,
          from: action.userId,
        },
      };
    }
    case "CLOSE_CREATE_HOMEWORK": {
      return { ...state, createHomework: null };
    }

    // Activity
    case "SET_ACTIVITY": {
      return { ...state, activity: action.activity };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
